export default __webpack_public_path__ + "economies714e89.png";